import type { RolePermission } from '../types';

export const UNGROUPED_LABEL = 'General';

export interface PermissionGroup {
  key: string;
  name: string;
  permissions: RolePermission[];
}

/** Group permissions by their feature label, with ungrouped ones bucketed last. */
export const groupPermissionsByFeature = (
  permissions: RolePermission[],
): PermissionGroup[] => {
  const groups = new Map<string, PermissionGroup>();
  for (const permission of permissions) {
    const name = permission.feature || UNGROUPED_LABEL;
    if (!groups.has(name)) {
      groups.set(name, { key: name, name, permissions: [] });
    }
    groups.get(name)!.permissions.push(permission);
  }
  return Array.from(groups.values()).sort((a, b) => {
    // Keep the catch-all "General" bucket last; sort the rest by name.
    if (a.name === UNGROUPED_LABEL) return 1;
    if (b.name === UNGROUPED_LABEL) return -1;
    return a.name.localeCompare(b.name);
  });
};
